module.exports = __webpack_public_path__ + "img/cta.b5bea780.jpg";